import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import RequireAuth from "./auth/RequireAuth";

import Login from "./pages/Login";
import Sessions from "./pages/Sessions";
import Participants from "./pages/Participants";
import Users from "./pages/Users";
import TdHost from "./pages/TdHost";
import NotFound from "./pages/NotFound";

/**
 * museumx admin — talks to the backend admin API (/api/admin/*).
 * All pages except /login require a valid JWT (see RequireAuth).
 */
export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route path="/sessions" element={<RequireAuth><Sessions /></RequireAuth>} />
      <Route path="/participants" element={<RequireAuth><Participants /></RequireAuth>} />
      <Route path="/users" element={<RequireAuth><Users /></RequireAuth>} />
      <Route path="/td-host" element={<RequireAuth><TdHost /></RequireAuth>} />

      <Route path="/" element={<Navigate to="/sessions" replace />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
